import React from "react"
import Head from "next/head"
import styles from "./CustomError.module.css"

const CustomError = ({ statusCode, title }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <Head>
        <title>
          {statusCode
            ? `${statusCode}: ${typeof title === "string" ? title : "Error"}`
            : "Error"}
        </title>
      </Head>
      <div className={styles.customError}>
        {statusCode && <h1>{statusCode}</h1>}
        <h2>{title}</h2>
      </div>
    </div>
  )
}

export default CustomError
